import CONSTS from '../../constants/actions';

export default (isOpen) => (dispatch) => {
  dispatch({
    type: isOpen ? CONSTS.SIDEBAR_OPEN : CONSTS.SIDEBAR_CLOSE,
  });
};
